import React from 'react';
import { elevesUrls } from 'containers/Eleves/urls';
import { ElevesView } from 'types/eleves';
import SchoolyearLink from 'components/Link/SchoolyearLink';
import { useDragListeners } from 'containers/Eleves/List/Table/Views/SortableItem';
import { inactiveItemStyle } from 'components/Tabs/TabsWithUnderline';

interface Props {
  view: ElevesView;
}

export function InactiveItem(props: Props) {
  const dragLi = useDragListeners();
  const { view } = props;
  return (
    <SchoolyearLink
      key={view.id}
      to={elevesUrls.viewDetails(view.id)}
      css={inactiveItemStyle}
      {...(dragLi?.listeners || {})}
    >
      {view.name}
    </SchoolyearLink>
  );
}
